<template>
<UpdateVehicleDetail Project="QM"/>
</template>

<script>
import UpdateVehicleDetail from '../PRODUCTION/Macchine/UpdateVehicleDetail.vue'

export default {
    components:{
        UpdateVehicleDetail
    }
}
</script>